import React, { useEffect, useState } from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
import { ArrowForward } from '@mui/icons-material';
export const ConsentTimelineListItem = (props) => {
    const { timelineActivity } = props;
    const [statusText, setStatusText] = useState('');
    // default text color and background color to "No Consent" and update it for opt in / opt out
    // const [textColorPreviousState, setTextColorPreviousState] = useState('#757575');
    // const [backgroundColorPreviousState, setBackgroundColorPreviousState] = useState('#F5F5F5');
    // const [textColorNewState, setTextColorNewState] = useState('#757575');
    // const [backgroundColorNewState, setBackgroundColorNewState] = useState('#F5F5F5');
    useEffect(() => {
        setStatusText(React.createElement(React.Fragment, null,
            timelineActivity.previousState,
            React.createElement(ArrowForward, { style: { fontSize: '18px', marginTop: 'auto', marginBottom: 'auto', marginLeft: '4px', marginRight: '4px' } }),
            timelineActivity.newState));
        if (timelineActivity.previousState === 'Consented') {
            // setTextColorPreviousState('#4CAF50');
            // setBackgroundColorPreviousState('#EEF7EE');
        }
        if (timelineActivity.previousState === 'Opt Out') {
            // setTextColorPreviousState('#D32F2F');
            // setBackgroundColorPreviousState('#FBEBEB');
        }
        if (timelineActivity.newState === 'Consented') {
            // setTextColorNewState('#4CAF50');
            // setBackgroundColorNewState('#EEF7EE');
        }
        if (timelineActivity.newState === 'Opt Out') {
            // setTextColorNewState('#D32F2F');
            // setBackgroundColorNewState('#FBEBEB');
        }
    });
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            React.createElement(TimelineListItemInfoChip, { label: 'PROGRAM', value: timelineActivity.program ?? '', backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }),
            React.createElement(TimelineListItemInfoChip, { label: 'STATUS', value: statusText, backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }),
            timelineActivity.reviewType &&
                React.createElement(TimelineListItemInfoChip, { label: timelineActivity.newState === 'Opted Out' ? 'REASON' : 'METHOD', value: timelineActivity.reviewType ?? '', backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false })),
        React.createElement("textarea", { style: {
                fontFamily: 'Lato, sans-serif',
                fontWeight: '400',
                fontSize: '16px',
                color: '#00000061',
                padding: '5px',
                width: '100%',
                border: '1px solid #0000003B',
                borderRadius: '4px',
                height: '65px',
                overflowY: 'scroll',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 transparent',
                display: timelineActivity.program == 'CGM' ? 'none' : 'block'
            }, value: timelineActivity.notes ?? '', readOnly: true })));
};
